/**
 * Part of the Campaign Page form (both charity and corporate)
 * Creates a list of 'partners' who are displayed on the CP/CCP
 * 
 * Adding/editing them saves some hidden fields, rather than updating on the DB in real-time
 * The DB entities are then synced when the whole form is submitted
 */

import ImageUploadCrop from 'Scripts/common/image-upload-crop';

export default class CorporatePartners {
	constructor() {
		this.ui = {
			hiddenForm: $('#js-corporate-list-form'), // All the values are stored in hidden inputs
			addForm: $('#js-corporate-add-form'),
			modal: $('#modal-campaign-corporate'),
			saveButton: $('.js-save-corp'),
			list: $("#js-corp-list"),
			noneAddedAlert: $(".js-corp-none"), // Box saying 'no partners added yet'
			error: $(".js-error-corp"),
		}

		// Init Cropper for logos
		this.logo = new ImageUploadCrop({
			width:     200,
			height:    150,
			restrict:  false,
			container: this.ui.modal,
			modal:     $('#js-modal-image-crop-corporate'),
			callback:  this.addLogo.bind(this),
		});

		// Empty array for managing the logos
		this.logos = [];

		this.bindEvents();
	}

	bindEvents() {
		this.ui.list.on('click', '.js-corp-move', this.onClickMovePartner.bind(this));
		this.ui.list.on('click', '.js-corp-edit', this.onClickEditPartner.bind(this));
		this.ui.list.on('click', '.js-corp-delete', this.deletePartner.bind(this));

		this.ui.addForm.on('submit', this.onSavePartner.bind(this));
	}

	onSavePartner(e) {
		console.log("CorporatePartners.onSavePartner()");

		e.preventDefault();

		const inputImage = this.logo.ui.cropResult;
		const id         = $(".js-corp-id").val();
		const name       = $(".js-corp-name").val();
		const website    = $(".js-corp-website").val();
		const logo       = inputImage.attr("src");
		const isEditing  = !!id;

		// If invalid, show an error
		if(name.trim() == "" || website.trim() == "" || (!isEditing && (logo == "" || inputImage.is(":hidden")))) {
			this.ui.error.collapse('show');
			return;
		}

		let partnerRow;
		
		// Are we editing an existing row or creating a new one using the <template> in the VM?
		if(isEditing) {
			partnerRow = $(".js-corp-single[data-id="+id+"]");
		} else {
			partnerRow = $($("#js-corp-template")[0].content.cloneNode(true));
		}

		partnerRow.find(".js-partner-name").text(name);
		partnerRow.find(".js-partner-website").attr('href', website).text(website);
		partnerRow.find(".js-partner-logo").attr("src", logo);
		partnerRow.find(".js-partner-name-input").val(name);
		partnerRow.find(".js-partner-website-input").val(website);

		const logoId = $(".js-corp-logo-id").val();

		if(logoId != "") {
			partnerRow.find(".js-partner-logo-input").val(logoId);
		}

		this.resetForm();

		if(!isEditing) {
			partnerRow.appendTo(this.ui.list);
			this.resetOrder();
		}
	}

	resetForm() {
		this.ui.addForm[0].reset();
		$(".js-corp-id").val(""); // reset() doesn't cover hidden fields

		this.ui.error.collapse('hide');
		this.logo.ui.cropResultContainer.collapse('hide');

		this.changeButton('add');
	}

	onClickEditPartner(e) {
		console.log("CorporatePartners.onClickEditPartner");

		const partnerRow = $(e.currentTarget).parents(".js-corp-single");

		$(".js-corp-id").val(partnerRow.find(".js-partner-id-input").val());
		$(".js-corp-name").val(partnerRow.find(".js-partner-name-input").val());
		$(".js-corp-website").val(partnerRow.find(".js-partner-website-input").val());

		this.logo.ui.cropResult.attr("src", partnerRow.find(".js-partner-logo").attr("src"));
		this.logo.ui.cropResultContainer.collapse("show");

		this.changeButton('edit');
	}

	changeButton(type) {
		this.ui.saveButton.find("span").text(this.ui.saveButton.data(type));
	}

	// After the corporate logo is cropped
	addLogo() {
		console.log("CorporatePartners.addLogo()");
		const modal = this.ui.modal;
		const event = 'shown.bs.modal';

		modal.modal('show');

		modal.on(event, () => {
			modal.animate({scrollTop: this.ui.addForm.offset().top - 200}, 200);	
			modal.off(event);
		});

		this.logos.push(this.logo.croppedImage);

		// Save the index of the logo in the array to the input, this is used later to fetch the blob
		$(".js-corp-logo-id").val(this.logos.length - 1);
	}

	// Change order of corporates - we don't have an order input as unnecessary, that field is set in the Java
	onClickMovePartner(e) {
		console.log("CorporatePartners.onClickMovePartner()");

		const el       = $(e.currentTarget);
		const dir      = el.data('dir');
		const parent   = el.parents(".js-corp-single");
		const newPos   = parent.index() + (dir == "up" ? 0 : 1);
		const selector = "#js-corp-list > :nth-child(" + newPos + ")";

		if(dir == "up" && newPos > 0) {
			parent.detach().insertBefore(selector);
		} else if(dir == "down" && newPos < this.ui.list.children().length){
			parent.detach().insertAfter(selector);
		}

		this.resetOrder();
	}

	// Need to make sure numbers are sequential otherwise Java validation fails
	resetOrder() {
		console.log("CorporatePartners.resetOrder()");

		const corporates = this.ui.list.find(".js-corp-single");

		// Update the index for each hidden input
		corporates.each((i, corporate) => {
			$(corporate).find("input").each((j,input) => {
				$(input).attr("name", $(input).attr("name").replaceAll(/[0-9]/g, i));
			});		
		});

		this.ui.noneAddedAlert.collapse(corporates.length ? 'hide' : 'show');
	}

	deletePartner(e) {
		console.log("CorporatePartners.deletePartner()");

 		if (window.confirm("Please confirm you want to remove the corporate partner")) {
			$(e.currentTarget).parents(".js-corp-single").remove();
			this.resetOrder();
		}
	}

	// The logo bit is a bit hacky, the input has the index of the array of saved blobs
	addToParentForm(parentFormData) {
		const formData = new FormData(this.ui.hiddenForm.get(0));

		for (let pair of formData.entries()) {
			let [ key, value ] = pair;

			if(key.endsWith(".logo")) {
				value = this.logos[value] || null;
			}
			
			if(value != null) {
				parentFormData.append(key, value);
			}
		}
	}
}